export const checkoutVersion = process.env.REACT_APP_CHECKOUT_VERSION;
export const CHECKOUT_VERSION = {
    V1: "1",
    V2: "2",
};

export const checkoutPagoScriptVersion =
    checkoutVersion === CHECKOUT_VERSION.V1
        ? process.env.REACT_APP_EPAYCO_APP_CHECKOUT
        : process.env.REACT_APP_EPAYCO_APP_CHECKOUT_V2;
